import FirestoreDocument from "../../../types/FirestoreDocument";
import FirestoreLifecycle from "../../../types/FirestoreLifecycle";
import {
	any,
	array,
	boolean,
	literal,
	nullable,
	object,
	record,
	string,
	timestamp,
	union,
} from "../../../types/_types";

import { Price } from "../../prices/types/Price";
import { StudioRef } from "../../studios/types/Studio";
import { UserRef } from "../../users/types/User";

import { SessionAgreement } from "./SessionAgreement";

export const Session = FirestoreDocument.extend({
	polish: boolean(),
	status: string(),
	managerIds: array(string()),
	managers: array(
		object({
			id: string(),
			name: nullable(string()),
			email: nullable(string()),
			img: nullable(string()),
		}),
	),
	recorder: nullable(string()),
	recorderData: union([UserRef, literal(false)]),
	priceId: nullable(string()),
	priceRef: nullable(union([Price, literal("default")])),
	agreementRef: nullable(SessionAgreement),
	studio: nullable(string()),
	studioGroup: nullable(string()),
	studioData: nullable(StudioRef),
	start: timestamp(),
	end: timestamp(),
	production: string(),
	productionData: object({
		ref: any(),
		id: string(),
		title: string(),
		producer: nullable(string()),
		publisher: nullable(string()),
		imgThumb: nullable(string()),
		language: nullable(string()),
	}),
	productionPriceRef: nullable(any()),
	producer: string(),
	reader: array(string()),
	readerData: nullable(record(string(), UserRef)),
	teamUserIds: array(string()),
}).merge(FirestoreLifecycle);
